import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CompanyModel } from 'src/app/core/models/masters/company-master-model';
import { EInvoiceModel, EwayBillDetails, EwayBillDetailsInven } from 'src/app/core/models/masters/eway.model';
import { UserProfileModel } from 'src/app/services/models/userModel';
import { EWayService } from '../e-way.service';
import { EWayCflPopupComponent } from '../e-way-cfl-popup/e-way-cfl-popup.component';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { DatePipe } from '@angular/common';
import { ValidationsComponent } from 'src/app/shared/validations/validations.component';
import { Router } from '@angular/router';
import { GlobalProperties } from 'src/app/global/global-properties';

@Component({
  selector: 'app-e-way-bill-popup',
  templateUrl: './e-way-bill-popup.component.html',
  styleUrls: ['./e-way-bill-popup.component.css'],
})
export class EWayBillPopupComponent implements OnInit{
    EwayBillDetails: EwayBillDetails = new EwayBillDetails();
    docData: any = new Object();
    logedInUserData: UserProfileModel = new UserProfileModel();
    companyData: CompanyModel = new CompanyModel();
    protected sessionService: any;
    subType: Array<any> = new Array();
    docType: Array<any> = new Array();
    canRemarks: Array<any> = new Array();
    vehicleType: Array<any> = new Array();
    transMode: Array<any> = new Array();
    transportList: Array<any> = new Array();
    allTransportData: Array<any> = new Array();
    stateList: Array<any> = new Array();
    hsnList: Array<any> = new Array();
    allHsnData: Array<any> = new Array();
    updateReason: Array<any> = new Array();
    supplyType: Array<any> = new Array();
    transactionType: Array<any> = new Array();
    transportCode: string = '';
    mainHsnEntry: string = '';
    screenType: number = 0;
    docEntry: string = '';
    objectType: string = '';
    ewayStatus: string = '';
    bredCrumbTitle: string = '';
    methodTypePatch: boolean = false;
    // reqData: WrapperInputModel<EWayDataModel> = new WrapperInputModel<EWayDataModel>();
    eWayBtn: string = '';
    eWayArr: Array<any> = new Array();
    billToStateGSTCode: string = '';
    shipToStateGSTCode: string = '';
    billFromStateGSTCode: string = '';
    dispatchFromStateGSTCode: string = '';
    eWayBillNo: string = '';
    StockTransferEwayDocEntry: string = '';
    alertResult: boolean = false;
    TransporterIndex: number | null = null;
    HSNIndex: number | null = null;
    BillFromStateIndex: string | null = null;
    BillToStateIndex: string | null = null;
    DispatchFromStateIndex: string | null = null;
    ShipToStateIndex: string | null = null;
    showValidationArr: string[] = [];
    IRN: string = '';
    reqData: WrapperStandardRequest<any> = new WrapperStandardRequest();
   constructor(public dialogRef: MatDialogRef<EWayBillPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
   public dialog: MatDialog, private ewayService: EWayService, private baseService: BaseService<any>, private router: Router) {

    if (data.masterList) {
      this.getMasterData(data);
    }
    this.getEwayArrData();
  }

  ngOnInit(): void {
    if (this.screenType == 0) {
      this.getBillToData();
      this.getBillFromData();
      this.getShipToGstCode();
    }
  }

   getMasterData(data: any) {
    this.subType = data?.masterList?.subType;
    this.docType = data?.masterList?.docType;
    this.canRemarks = data?.masterList?.canRemarks;
    this.vehicleType = data?.masterList?.vehicleType;
    this.transMode = data?.masterList?.transMode;
    this.transportList = data?.masterList?.transportList;
    this.allTransportData = data?.masterList?.allTransportData;
    this.hsnList = data?.masterList?.hsnList;
    this.allHsnData = data?.masterList?.allHsnData;
    this.updateReason = data?.masterList?.updateReason;
    this.supplyType = data?.masterList?.supplyType;
    this.transactionType = data?.masterList?.transactionType;
    this.stateList = data?.masterList.stateList;
    this.EwayBillDetails = data?.eWayGetData;
    this.screenType = data?.screenType;
    // this.docData = data?.docData;
    this.transportCode = data?.transportCode;
    this.objectType = data?.objectType;
    this.methodTypePatch = data?.methodTypePatch;
    this.IRN = data?.IRN;
    // this.docData.U_UTL_CARES = this.docData.U_UTL_CARES ? Number(this.docData.U_UTL_CARES) : null;
    this.billFromStateGSTCode = this.getState(this.EwayBillDetails.BillFromStateGSTCode);
    this.billToStateGSTCode = this.getState(this.EwayBillDetails.BillToStateGSTCode);
    this.dispatchFromStateGSTCode = this.getState(this.EwayBillDetails.DispatchFromStateGSTCode);
    this.shipToStateGSTCode = this.getState(this.EwayBillDetails.ShipToStateGSTCode);
    this.BillFromStateIndex = this.billFromStateGSTCode;
    this.BillToStateIndex = this.billToStateGSTCode;
    this.DispatchFromStateIndex = this.dispatchFromStateGSTCode;
    this.ShipToStateIndex = this.shipToStateGSTCode;
    this.mainHsnEntry = this.ewayService.getValues(this.allHsnData, this.EwayBillDetails.MainHSNEntry, 'absEntry', 'chapterID');
    this.HSNIndex = this.ewayService.getValues(this.allHsnData, this.EwayBillDetails.MainHSNEntry, 'absEntry', 'chapter');
  }

  getState(stateCode: string) {
    const state = this.stateList.find((el) => {
      if(!stateCode) {
       return false;
      }
      return el.GSTCode == +stateCode;
    })
    return state ? state.Name : '';
  }

  openDialog(dataList: Array<any>, type: string) {
    let cflPopupPaylod: any = {
        title: type,
        info: dataList,
        selectedIndex: 0
    }
    switch (type) {
      case 'Transporter':
        cflPopupPaylod.selectedIndex = this.TransporterIndex;
        break;
      case 'Main HSN':
        cflPopupPaylod.selectedIndex = this.HSNIndex;
        break;
      case 'BillTo':
        cflPopupPaylod.selectedIndex = this.BillToStateIndex;
        break;
      case 'BillFrom':
        cflPopupPaylod.selectedIndex = this.BillFromStateIndex;
        break;  
      case 'DispatchFrom':
        cflPopupPaylod.selectedIndex = this.DispatchFromStateIndex;
      break;  
      case 'ShipTo':
        cflPopupPaylod.selectedIndex = this.ShipToStateIndex;
      break;  
    }
    this.dialog.open(EWayCflPopupComponent, {
      width: '800px',
      data: cflPopupPaylod,
    }).afterClosed().subscribe((res: any) => {
      if (res?.event) {
        switch (type) {
          case 'Transporter':
            this.transportCode = res?.event.TransporterCode
            this.EwayBillDetails.TransporterEntry = res?.event.TransporterEntry;
            this.EwayBillDetails.TransporterLineNumber = res?.event.TransporterLineNumber;
            this.EwayBillDetails.TransportationMode = res?.event.Mode;
            this.EwayBillDetails.TransporterID = res?.event?.TransporterId;
            this.EwayBillDetails.TransporterName = res?.event?.TransporterName;
            this.EwayBillDetails.VehicleNo = res?.event?.VehicleNo;
            this.EwayBillDetails.VehicleType = res?.event?.VehicleType;
            this.TransporterIndex = res?.event['#'];
            break;
          case 'Main HSN':
            this.mainHsnEntry = this.ewayService.getValues(this.allHsnData, res?.event?.Chapter, 'chapter', 'chapterID');
            this.EwayBillDetails.MainHSNEntry = this.ewayService.getValues(this.allHsnData, res?.event?.Chapter, 'chapter', 'absEntry');
            this.HSNIndex = res?.event?.Chapter;
            break;
          case 'BillTo':
            this.billToStateGSTCode = res?.event?.Name;
            this.EwayBillDetails.BillToStateGSTCode = res?.event?.GSTCode;
            this.BillToStateIndex = res?.event?.Name;
            break;
          case 'BillFrom':
            this.billFromStateGSTCode = res?.event?.Name;
            this.EwayBillDetails.BillFromStateGSTCode = res?.event?.GSTCode;
            this.BillFromStateIndex = res?.event?.Name;
            break;
          case 'DispatchFrom':
            this.dispatchFromStateGSTCode = res?.event?.Name;
            this.EwayBillDetails.DispatchFromStateGSTCode = res?.event?.GSTCode;
            this.DispatchFromStateIndex = res?.event?.Name;
            break;
          case 'ShipTo':
            this.shipToStateGSTCode = res?.event?.Name;
            this.EwayBillDetails.ShipToStateGSTCode = res?.event?.GSTCode;
            this.ShipToStateIndex = res?.event?.Name;
            break;  
        }
      }
    });
  }

  getTransportValues(list: Array<any>, value: any, propertyName: string) {
    if (value) {
      return list?.filter(el => (el.TransporterCode == value.TransporterCode) && (el.VehicleNo == value.VehicleNo))[0][propertyName];
    }
  }

  getBillToData() {
    if (!this.data?.customerCode) {
      return
    }
    this.reqData.RequestData = this.data?.customerCode;
    this.ewayService.getBillToData(this.reqData).subscribe(res => {
      const response = res?.responseData;
      if (response.billToDetails.length == 0) {
        return
      }
      let billToData = response.billToDetails[0];
      this.EwayBillDetails.BillToName = billToData.billToName;
      this.EwayBillDetails.BillToGSTIN = billToData.billToGSTIN;
      this.EwayBillDetails.BillToStateGSTCode = billToData.gstCode;
      this.billToStateGSTCode = billToData.billToState;
    });
  }

  getShipToGstCode() {
    let shipObj: any = new Object;
    shipObj = this.data?.shipToData.shipList?.filter((el: any) => el.addressName == this.data?.shipToData?.value)[0];
    this.EwayBillDetails.ShipToAddress1 = this.setShipToData(shipObj);
    this.EwayBillDetails.ShipToPlace = shipObj?.city;
    this.shipToStateGSTCode = shipObj?.block;
    this.EwayBillDetails.ShipToZipCode = shipObj?.zipCode;
    let stateUrl: string = `States?$filter=Code eq '${shipObj?.state}'`;
    // this.ewayService.getMoreOrders(stateUrl).subscribe(info => {
    //   if (info?.value) {
    //     this.EwayBillDetails.ShipToStateGSTCode = info?.value[0]?.GSTCode;
    //   }
    // });
  }

  getBillFromData() {
    if (!this.data?.wareHouseCode) {
      return
    }
    this.reqData.RequestData = this.data?.wareHouseCode;
    this.ewayService.getBillFromData(this.reqData).subscribe(res => {
      const response = res?.responseData;
      if (response.billFromDetails.length == 0) {
        return
      }
      let billFromData = response.billFromDetails[0];
      this.EwayBillDetails.BillFromName = billFromData.billFromName;
      this.EwayBillDetails.BillFromGSTIN = billFromData.billFromGSTIN;
      this.EwayBillDetails.BillFromStateGSTCode = billFromData.gstCode;
      this.billFromStateGSTCode = billFromData.billFromState;
      this.EwayBillDetails.DispatchFromAddress1 = this.getBillFromAddress(billFromData);
      this.EwayBillDetails.DispatchFromPlace = billFromData.billFromCity;
      this.EwayBillDetails.DispatchFromStateGSTCode = billFromData.gstCode;
      this.dispatchFromStateGSTCode = billFromData.billFromState;
      this.EwayBillDetails.DispatchFromZipCode = billFromData.billFromZipCode;
    });
  }

  getBillToAddress(item: any) {
    let arr = [];
    item.billToBuilding ? arr.push(item.billToBuilding) : false;
    item.billToBlock ? arr.push(item.billToBlock) : false;
    item.billToStreet ? arr.push(item.billToStreet) : false;
    item.billToCity ? arr.push(item.billToCity) : false;
    item.billToZipCode ? arr.push(item.billToZipCode) : false;
    item.billToCountry ? arr.push(item.billToCountry) : false;
    return arr.join(', ')
  }

  getBillFromAddress(item: any) {
    let arr = [];
    item.billFromBuilding ? arr.push(item.billFromBuilding) : false;
    item.billFromBlock ? arr.push(item.billFromBlock) : false;
    item.billFromStreet ? arr.push(item.billFromStreet) : false;
    item.billFromCity ? arr.push(item.billFromCity) : false;
    item.billFromZipCode ? arr.push(item.billFromZipCode) : false;
    item.billFromCountry ? arr.push(item.billFromCountry) : false;
    return arr.join(', ')
  }

  selectEWay(type: string, redirectTo="") {
      
    if (this.checkEwayBillNo(type)) {
      return
    }
    if (this.checkMandatoryFields(type)) {
      return
    }

    if(this.objectType == '67') {
      redirectTo = '/home/inventory/inventorytransferlistview/';
    }else {
      redirectTo = '/home/sales/salesInvoiceListView';
    }

    let payload: WrapperStandardRequest<EInvoiceModel> = new WrapperStandardRequest<EInvoiceModel>();
    delete payload.RequestData;
    (payload as any).data = {
        "companyDB": GlobalProperties._companyDb,
        "password": "1234",
        "userName": "UTL2156",
        "dbInstance": "HANADB",
       // "serviceLayerUrl": "https://fp2405.uneecopscloud.com:50000/b1s/v2/",
         "serviceLayerUrl": "https://fp2502:50000/b1s/v2/",
        "_DocEntry": this.data.docEntry == undefined ? (this.docEntry).toString() : (this.data.docEntry).toString(),
        "_ObjectType": this.objectType,
        "_DBConnection": "INT_WMSDEVSAPHANA_190",
        "databaseServerType": "HANA",
        "apiGateWayUrl": "string",
        "layoutName": "string",
        "layoutId": "string",
        "actionName": type,
        "documentCode": "string",
        "irn": this.IRN,
        "returnDataQueryURL": "http://fs.uneecopscloud.com:8484/FetchData/V2",
        "u_UTL_ST_ESTATUS": "string",
        "u_UTL_ST_EWBSts": "string",
        "eWayBillNo": this.data.docEntry == undefined ? this.eWayBillNo : this.EwayBillDetails.EWayBillNo,
        "stockTransferEwayDocEntry": this.data.ewayDocEntry == undefined ? this.StockTransferEwayDocEntry : this.data?.ewayDocEntry,
        "_StrSequence": "string",
        "Reason": type == 'UpdateEwayBill' ? this.EwayBillDetails.U_UTL_ST_UPRESR 
        : type == 'CancelEwayBill' ? this.EwayBillDetails.U_UTL_CARES : '',
        "Remark": type == 'UpdateEwayBill' ? this.EwayBillDetails.U_UTL_ST_URMK 
        : type == 'CancelEwayBill' ? this.EwayBillDetails.U_UTL_ST_CANRMK : '',
    }
    this.ewayService.postEinvoiceData(payload).subscribe((res: any) => {
      res = res.data;
      if (res?.status == '0' && !res.data) {
        this.baseService.showMessage(res?.errorDetail.slice(0, 150), 'X');
        if(this.screenType == 0) {
           this.router.navigate([redirectTo]);
        }
        return
      }
      let result: any = JSON.parse(res.data)[0];
      if(result.flag) {
         if (this.objectType == '13' && this.data?.withIRN) {
          switch (type) {
            case 'GenerateEwayBill':
              this.EwayBillDetails.EWayBillDate = result?.EwbDt ? new Date(result.EwbDt) : null;
              this.EwayBillDetails.EWayBillNo = result?.EwbNo ? (result?.EwbNo).toString() : '';
              this.EwayBillDetails.EWayBillExpirationDate = result?.EwbValidTill ? new Date(result?.EwbValidTill) : null;
              break;
            case 'CancelEwayBill':
              this.docData.U_UTL_ST_CANDAT = new Date(this.getDateFormat(result?.cancelDate));
              break;
            case 'UpdateEwayBill':
              this.EwayBillDetails.EWayBillExpirationDate = result?.validUpto ? new Date(this.getDateFormat(result?.validUpto)) : null;
              this.docData.U_UTL_ST_EWayUpDt = result?.vehUpdDate ? new Date(this.getDateFormat(result?.vehUpdDate)) : null;
              break;
          }
        } else {
          switch (type) {
            case 'GenerateEwayBillNonIRN':
              this.EwayBillDetails.EWayBillDate = result?.ewayBillDate ? new Date(this.getDateFormat(result?.ewayBillDate)) : null;
              this.EwayBillDetails.EWayBillNo = result?.ewayBillNo ? (result?.ewayBillNo.toString()) : '';
              this.EwayBillDetails.EWayBillExpirationDate = result?.validUpto ? new Date(this.getDateFormat(result?.validUpto)) : null;
              break;
            case 'CancelEwayBillNonIRN':
              this.docData.U_UTL_ST_CANDAT = new Date(this.getDateFormat(result?.cancelDate));
              break;
            case 'UpdateEwayBillNonIRN':
              this.EwayBillDetails.EWayBillExpirationDate = result?.validUpto ? new Date(this.getDateFormat(result?.validUpto)) : null;
              this.docData.U_UTL_ST_EWayUpDt = result?.vehUpdDate ? new Date(this.getDateFormat(result?.vehUpdDate)) : null;
              break;
          }
        }
      }
      this.baseService.showMessage(`${result.message}`, 'X');
      this.docData.U_UTL_ST_EWBSts = result?.eWayBillStatus;
      if(this.screenType == 0) {
           this.router.navigate([redirectTo]);
      }
    });
  }

  checkEwayBillNo(type: string) {
    let flag: boolean = false;
    if (type == 'GenerateEwayBill' || type == 'GenerateEwayBillNonIRN') {
      if (this.EwayBillDetails.EWayBillNo) {
        this.baseService.showMessage('Eway Bill Already Generated', 'X');
        flag = true;
      }
    } else {
      if (!this.EwayBillDetails.EWayBillNo) {
        this.baseService.showMessage('Please Generate Eway Bill', 'X');
        flag = true;
      }
    }
    return flag
  }

  checkMandatoryFields(type: string) {
    let arr: Array<any> = new Array();
    switch (type) {
      case 'CancelEwayBill':
      case 'CancelEwayBillNonIRN':
        this.docData.U_UTL_ST_CANDAT ? arr.push('Eway Bill Already Cancelled') : false;
        !this.EwayBillDetails.U_UTL_CARES ? arr.push('Please Select Cancel Reason') : false;
        !this.EwayBillDetails.U_UTL_ST_CANRMK ? arr.push('Please Select Cancel Remark') : false;
        break;
      case 'UpdateEwayBill':
      case 'UpdateEwayBillNonIRN':
        this.docData.U_UTL_ST_CANDAT ? arr.push('Eway Bill Already Cancelled') : false;
        !this.EwayBillDetails.U_UTL_ST_UPRESR ? arr.push('Please Select Update Reason') : false;
        !this.EwayBillDetails.U_UTL_ST_URMK ? arr.push('Please Select Update Remark') : false;
        break;
    }
    arr.length > 0 ? this.baseService.showMessage(arr.join(', '), 'X') : false;
    return arr.length > 0 ? true : false
  }

   getDateFormat(date: string) {
    let str = date.split('/');
    let result = `${str[2].split(' ')[0]}-${str[1]}-${str[0]}`;
    return result;
  }

  validate() {
      
    var isValid: boolean = false;
    if (!this.EwayBillDetails.SupplyType && !this.EwayBillDetails.SubType
      && !this.EwayBillDetails.DocumentType && !this.EwayBillDetails.TransactionType
      && !this.mainHsnEntry
      // && this.docData.U_UTL_CARES == null && this.docData.U_UTL_ST_CANRMK == ""
      // && this.docData.U_UTL_ST_UPRESR == "" && this.docData.U_UTL_ST_URMK == ""
      && !this.transportCode
      && !this.EwayBillDetails.TransporterName && !this.EwayBillDetails.TransporterID
      && !this.EwayBillDetails.TransportationMode
      && !this.EwayBillDetails.VehicleType && !this.EwayBillDetails.VehicleNo
      && !this.EwayBillDetails.Distance && !this.EwayBillDetails.TransporterDocNo && !this.EwayBillDetails.TransporterDocDate
    ) {//all fields blank

      this.showValidationArr[0] = 'Please fill all mandatory fields';
      this.showValidationAlert();

    } else if (
      // (this.EwayBillDetails.SupplyType != "" && this.EwayBillDetails.SubType != null
      // && this.EwayBillDetails.DocumentType != "" && this.EwayBillDetails.TransactionType != ""
      // && this.mainHsnEntry != null
      // && this.docData.U_UTL_CARES != null && this.docData.U_UTL_ST_CANRMK != ""
      // && this.docData.U_UTL_ST_UPRESR != "" && this.docData.U_UTL_ST_URMK != ""
      // && this.EwayBillDetails.TransportationMode != null
      // && this.EwayBillDetails.VehicleType != "" && this.EwayBillDetails.VehicleNo != ""
      // && this.EwayBillDetails.Distance != null && this.EwayBillDetails.TransporterDocNo != "" && this.EwayBillDetails.TransporterDocDate != null)
      // && 
      this.transportCode == "" || this.EwayBillDetails.TransporterName == "" || this.EwayBillDetails.TransporterID == "") {

      this.showValidationArr[0] = 'Please fill Transaction Code, Transaction Name and Transaction Id';
      this.showValidationAlert();

    } else if ((!this.EwayBillDetails.SupplyType && !this.EwayBillDetails.SubType
      && !this.EwayBillDetails.DocumentType && !this.EwayBillDetails.TransactionType
      && !this.mainHsnEntry
      // && this.docData.U_UTL_CARES == null && this.docData.U_UTL_ST_CANRMK == ""
      // && this.docData.U_UTL_ST_UPRESR == "" && this.docData.U_UTL_ST_URMK == ""
      && !this.EwayBillDetails.Distance && !this.EwayBillDetails.TransporterDocNo && !this.EwayBillDetails.TransporterDocDate)
      && this.EwayBillDetails.TransportationMode
      && this.EwayBillDetails.VehicleType && this.EwayBillDetails.VehicleNo
      && this.transportCode && this.EwayBillDetails.TransporterName && this.EwayBillDetails.TransporterID) {

      this.showValidationArr[0] = 'E-Way Bill parte will generate, Do you want to continue?';
      this.showValidationAlert();

    } else {
      isValid = true;
    }
    return isValid;
  }

  save() {
    if (this.objectType == '13') {
      this.saveEwayForARInvoice();
      // if (this.validate()) {
      //   this.saveEwayForARInvoice();
      // }
    } else {
      if (this.validate()) {
        if (this.screenType == 0) {
          this.saveEwayForTransForDialog();
        } else {
          this.saveEwayInTra('/home/inventory/inventorytransferlistview/', this.transportCode);
        }
      }
    }
  }

  saveEwayForARInvoice() {
    let saveData: EwayBillDetails = new EwayBillDetails();
    saveData = JSON.parse(JSON.stringify(this.EwayBillDetails));
    saveData.EWayBillDate = this.ewayService.getFormatDate(saveData.EWayBillDate);
    saveData.EWayBillExpirationDate = this.ewayService.getFormatDate(saveData.EWayBillExpirationDate);
    saveData.TransporterDocDate = this.ewayService.getFormatDate(saveData.TransporterDocDate);
    saveData.Distance = Number(saveData.Distance);
    this.dialogRef.close({ orgValue: this.EwayBillDetails, saveData: saveData, transportCode: this.transportCode, docData: this.docData });
    //    this.dialogRef.close({ orgValue: this.EwayBillDetails, MethodTypePatch: false, transportCode: this.transportCode, ewayDocEntry: this.data?.ewayDocEntry });
  }

  saveEwayForTransForDialog(){
    let saveData: EwayBillDetails = new EwayBillDetails();
    saveData = JSON.parse(JSON.stringify(this.EwayBillDetails));
    saveData.EWayBillDate = this.ewayService.getFormatDate(saveData.EWayBillDate);
    saveData.EWayBillExpirationDate = this.ewayService.getFormatDate(saveData.EWayBillExpirationDate);
    saveData.TransporterDocDate = this.ewayService.getFormatDate(saveData.TransporterDocDate);
    saveData.Distance = Number(saveData.Distance);
    this.dialogRef.close({ orgValue: this.EwayBillDetails, MethodTypePatch: false, transportCode: this.transportCode, ewayDocEntry: this.data?.ewayDocEntry });
    //this.dialogRef.close({ orgValue: this.EwayBillDetails, saveData: saveData });
  }

   saveEwayInTra(redirectTo: string = '', transportCode: string="") {
    var pipe = new DatePipe('en-US');
    let invTraObj: EwayBillDetailsInven = new EwayBillDetailsInven();
    invTraObj.U_UTL_ST_DocEnt = (this.docData.DocEntry).toString();
    invTraObj.U_UTL_ST_BSobjTyp = this.objectType;
    invTraObj.U_UTL_ST_SuplyType = this.EwayBillDetails.SupplyType;
    invTraObj.U_UTL_ST_SubSplyTyp = this.EwayBillDetails.SubType!=null?(this.EwayBillDetails.SubType!).toString():'';
    invTraObj.U_UTL_ST_DocType = this.EwayBillDetails.DocumentType;
    invTraObj.U_UTL_ST_TransTyp = this.EwayBillDetails.TransactionType;
    invTraObj.U_UTL_ST_MainHsnEnt = this.EwayBillDetails.MainHSNEntry;
    invTraObj.U_UTL_ST_EwayBillNo = this.EwayBillDetails.EWayBillNo;
    invTraObj.U_UTL_ST_EwbDate = this.ewayService.getFormatDate(this.EwayBillDetails.EWayBillDate);
    invTraObj.U_UTL_ST_ExpireDate = this.ewayService.getFormatDate(this.EwayBillDetails.EWayBillExpirationDate);
    invTraObj.U_UTL_ST_TransCode = transportCode;
    invTraObj.U_UTL_ST_TransID = this.EwayBillDetails.TransporterID;
    invTraObj.U_UTL_ST_TransName = this.EwayBillDetails.TransporterName;
    invTraObj.U_UTL_ST_TransDocNo = this.EwayBillDetails.TransporterDocNo;
    invTraObj.U_UTL_ST_TransDate = (this.ewayService.getFormatDate(pipe.transform(this.EwayBillDetails.TransporterDocDate,'y-MM-d')));
    invTraObj.U_UTL_ST_TransMode = (this.EwayBillDetails.TransportationMode!)?.toString();
    invTraObj.U_UTL_ST_Distance = this.EwayBillDetails.Distance;
    invTraObj.U_UTL_ST_VehicleTyp = this.EwayBillDetails.VehicleType;
    invTraObj.U_UTL_ST_VehicleNo = this.EwayBillDetails.VehicleNo;
    invTraObj.U_UTL_ST_FrmTraName = this.EwayBillDetails.BillFromName;
    invTraObj.U_UTL_ST_FrmGSTN = this.EwayBillDetails.BillFromGSTIN;
    invTraObj.U_UTL_ST_FrmAdd1 = this.EwayBillDetails.DispatchFromAddress1;
    invTraObj.U_UTL_ST_FrmAdd2 = this.EwayBillDetails.DispatchFromAddress2;
    invTraObj.U_UTL_ST_FrmZipCode = this.EwayBillDetails.DispatchFromZipCode;
    invTraObj.U_UTL_ST_ToTraName = this.EwayBillDetails.BillToName;
    invTraObj.U_UTL_ST_ToGSTN = this.EwayBillDetails.BillToGSTIN;
    invTraObj.U_UTL_ST_ToAdd1 = this.EwayBillDetails.ShipToAddress1;
    invTraObj.U_UTL_ST_ToAdd2 = this.EwayBillDetails.ShipToAddress2;
    invTraObj.U_UTL_ST_ToZipCode = this.EwayBillDetails.ShipToZipCode;
    invTraObj.U_UTL_ST_FrmPlace = this.EwayBillDetails.DispatchFromPlace;
    invTraObj.U_UTL_ST_ToPlace = this.EwayBillDetails.ShipToPlace;
    invTraObj.U_UTL_ST_ActToState = this.EwayBillDetails.ShipToStateGSTCode;
    invTraObj.U_UTL_ST_FrmState = this.EwayBillDetails.DispatchFromStateGSTCode;
    invTraObj.U_UTL_ST_CANDT = this.ewayService.getFormatDate(this.docData.U_UTL_ST_CANDAT);
    invTraObj.U_UTL_ST_CARES = this.docData.U_UTL_CARES;
    invTraObj.U_UTL_ST_CANRMK = this.docData.U_UTL_ST_CANRMK;
    invTraObj.U_UTL_ST_UPRESR = this.docData.U_UTL_ST_UPRESR;
    invTraObj.U_UTL_ST_URMK = this.docData.U_UTL_ST_URMK;
    invTraObj.U_UTL_ST_UPDT = this.ewayService.getFormatDate(this.docData.U_UTL_ST_EWayUpDt);
    this.ewayService.saveEwayInTrans(invTraObj, this.methodTypePatch, this.data?.ewayDocEntry).subscribe(res => {
      this.baseService.showMessage(this.methodTypePatch ? 'EWay Bill Updated' : 'EWay Bill Created', 'X');
      if (this.screenType == 0) {
        //Generate eWayBill
        this.eWayBillNo=res.ewayBillNo;
        this.StockTransferEwayDocEntry=res.DocEntry;  
        this.selectEWay('GenerateEwayBillNonIRN', redirectTo);
      } else {
        this.dialogRef.close({ orgValue: this.EwayBillDetails, MethodTypePatch: true, transportCode: this.transportCode, ewayDocEntry: !this.methodTypePatch ? res?.DocEntry : this.data?.ewayDocEntry });
      }
    })
  }

  setShipToData(shipObj: any) {
    let dataArr: Array<any> = ['buildingFloorRoom', 'street', 'streetNo', 'block', 'city', 'zipCode', 'country'];
    let resultArr: Array<any> = new Array();
    dataArr.forEach((el: string) => {
      if (shipObj[el]) {
        resultArr.push(shipObj[el]);
      }
    })
    return resultArr.join(', ');
  }

  showValidationAlert() {
    let filterDialogRef = this.dialog.open(ValidationsComponent, {
        // height: '100%',
        width: '400px',
        panelClass: 'validatesection',
        position: { right: 0 + 'px', top: 56 + 'px' },
        data: {
            showValidation: this.showValidationArr,
            title: 'E-Way Bill Validation'
        }
    });
    filterDialogRef.afterClosed().subscribe((res: any) => {
      if (res.event == true) {
        this.alertResult = true;
        if (this.showValidationArr[0] == 'E-Way Bill parte will generate, Do you want to continue?') {
          if (this.objectType == '13') {
            //          this.saveEwayForARInvoice();
          }else {
            this.saveEwayForTransForDialog();
          }
        }
      } else {
        this.alertResult = false;
      }
    });
  }

  getEwayArrData() {
    if (this.objectType == '13' && this.data?.withIRN) {
      this.eWayArr = [
        { key: 'Generate Eway Bill', value: 'GenerateEwayBill' },
        { key: 'Cancel Eway Bill', value: 'CancelEwayBill' },
        { key: 'Update Eway Bill', value: 'UpdateEwayBill' }
      ]
    } else {
      let str: string = !this.data?.withIRN ? ' (B2C)' : '';
      this.eWayArr = [
        { key: 'Generate Eway Bill' + str, value: 'GenerateEwayBillNonIRN' },
        { key: 'Cancel Eway Bill' + str, value: 'CancelEwayBillNonIRN' },
        { key: 'Update Eway Bill' + str, value: 'UpdateEwayBillNonIRN' }
      ]
    }
  }

}
